export enum ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
  INTERVIEWER = 'INTERVIEWER'
}
